import { IRutinInfo } from '../../../../../Types/RutinInfoType';

const MUStyrvardeMeny: IRutinInfo[] = [];

export default MUStyrvardeMeny;
